export default __webpack_public_path__ + "b225571223dda1eac783432623707b9b.svg";